<template>
  <div class="detail-dialog">
    <v-dialog
      v-show="detailDialog"
      v-model="detailDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline grey darken-4 white--text">
          <span class="headline">{{ currentBrain.title.value }}</span>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="setDetailDialog(false)">Close</v-btn>
        </v-card-title>
        <v-row justify="center" class="brain-thumbnail">
          <div v-viewer.rebuild="{inline: true}">
            <img :src="currentBrain.thumbnail" />
          </div>
        </v-row>
        <v-row dense justify="end" class="pt-3">
          <!-- Change thumbnail -->
          <v-col cols="4">
            <v-btn
              color="success"
              class="text-none"
              small
              :loading="isUploading"
              :disabled="isUploading"
              @click="selectFile"
            >
              <v-icon>mdi-image</v-icon>
              Change thumbnail...
            </v-btn>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".jpg,.jpeg,.png"
              @change="uploadThumbnail"
            />
          </v-col>
          <v-col cols="2">
            <v-menu
              offset-y
              max-width="200"
              min-width="200"
              :close-on-click="true"
              :close-on-content-click="true"
            >
              <template v-slot:activator="{on}">
                <v-btn v-on="on" small>
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-if="profile.AccountId === currentBrain.owner.id"
                  link
                  @click="setShareDialog(true)"
                >
                  <v-list-item-title>Share</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="profile.AccountId === currentBrain.owner.id"
                  link
                  :disabled="deleting"
                  @click="deleteThis()"
                >
                  <v-list-item-title>Archive</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="setProfileDialog(true)">
                  <v-list-item-title>Owner</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-text class="pb-0">
          <v-row v-if="irregularExtension" dense justify="end">
            <span class="error--text">
              You can only upload ".jpg", ".jpeg", or ".png" file.
            </span>
          </v-row>
        </v-card-text>
        <v-card-text class="pb-0 pt-2">
          <v-row justify="end" class="subtitle-2">
            <span>Created at: {{ currentBrain.created_at }}</span>
            <span class="pl-4">
              Last updated: {{ currentBrain.updated_at }}
            </span>
          </v-row>
          <v-row justify="end" class="caption">
            <span>ID: {{ currentBrain.id }}</span>
          </v-row>
        </v-card-text>
        <v-list-item>
          <v-list-item-content class="mt-3 ml-3">
            <!-- Title -->
            <v-form
              ref="form"
              v-model="currentBrain.title.updatable"
              @submit.prevent
            >
              <v-row dense>
                <v-col cols="3" class="pb-5">Title</v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="currentBrain.title.dispValue"
                    name="title"
                    :readonly="!currentBrain.title.editable"
                    :rules="currentBrain.title.rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" v-if="currentBrain.title.editable" class="pb-5">
                  <v-btn
                    icon
                    color="success"
                    class="mr-2 ml-3"
                    @click="save('Title', 'title')"
                    :loading="currentBrain.title.loading"
                    :disabled="!currentBrain.title.updatable"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                  <v-btn text color="warning" @click="cancel('title')">
                    cancel
                  </v-btn>
                </v-col>
                <v-col v-else cols="3" class="pb-5">
                  <v-btn
                    v-if="
                      $route.name !== 'brains_share' &&
                        $route.name !== 'brains_public'
                    "
                    text
                    color="success"
                    @click="edit('title')"
                  >
                    edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <!-- Status -->
            <v-row dense>
              <v-col cols="3" class="pb-5">Status</v-col>
              <v-col cols="6">
                <brain-status
                  :status="currentBrain.preprocessingStatus"
                ></brain-status>
              </v-col>
            </v-row>
            <!-- Strain -->
            <v-form
              ref="form"
              v-model="currentBrain.strain.updatable"
              @submit.prevent
            >
              <v-row v-if="currentBrain.strain.editable" dense>
                <v-col cols="3" class="pb-5">Strain</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="currentBrain.strain.dispValue"
                    :items="conditions.mouseLines.items"
                    chips
                    name="strain"
                    item-text="Title"
                    item-value="ItemId"
                  >
                    <template v-slot:selection="{item}">
                      <v-chip
                        :color="'#' + item.Color"
                        :dark="!isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ item.Title }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="3" class="pb-5">
                  <template v-if="currentBrain.strain.updatable">
                    <v-btn
                      icon
                      color="success"
                      class="mr-2 ml-3"
                      @click="save('Strain', 'strain')"
                      :loading="currentBrain.strain.loading"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn icon class="mr-2 ml-3" disabled>
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <v-btn text color="warning" @click="cancel('strain')">
                    cancel
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else dense>
                <v-col cols="3" class="pb-5">Strain</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="currentBrain.strain.dispValue"
                    :items="conditions.mouseLines.items"
                    chips
                    name="strain"
                    item-text="Title"
                    item-value="ItemId"
                    readonly
                  >
                    <template v-slot:selection="{item}">
                      <v-chip
                        :color="'#' + item.Color"
                        :dark="!isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ item.Title }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="3"
                  class="pb-5"
                  v-if="
                    $route.name !== 'brains_share' &&
                      $route.name !== 'brains_public'
                  "
                >
                  <v-btn text color="success" @click="edit('strain')">
                    edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <!-- Age -->
            <v-form
              ref="form"
              v-model="currentBrain.age.updatable"
              @submit.prevent
            >
              <v-row v-if="currentBrain.age.editable" dense>
                <v-col cols="3" class="pb-5">Age</v-col>
                <v-col cols="6">
                  <v-row class="py-0">
                    <v-col class="py-0">
                      <v-text-field
                        v-model="currentBrain.age.dispValue"
                        outlined
                        dense
                        name="age"
                        :rules="currentBrain.age.rules"
                      ></v-text-field>
                    </v-col>
                    <v-col align-self="center" class="py-0">
                      <v-select
                        v-model="currentBrain.age.dispPeriod"
                        :items="['days', 'weeks', 'months']"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="3" class="pb-5">
                  <template v-if="currentBrain.age.updatable">
                    <v-btn
                      icon
                      color="success"
                      class="mr-2 ml-3"
                      @click="save('Age', 'age')"
                      :loading="currentBrain.age.loading"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn icon class="mr-2 ml-3" disabled>
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <v-btn text color="warning" @click="cancel('age')">
                    cancel
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else dense>
                <v-col cols="3" class="pb-5">Age</v-col>
                <v-col cols="6">
                  <v-row class="py-0">
                    <v-col class="py-0">
                      <v-text-field
                        v-model="currentBrain.age.dispValue"
                        filled
                        single-line
                        dense
                        readonly
                        name="age"
                      ></v-text-field>
                    </v-col>
                    <v-col align-self="center" class="py-0 pb-5">
                      <span>{{ currentBrain.age.period }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="3"
                  class="pb-5"
                  v-if="
                    $route.name !== 'brains_share' &&
                      $route.name !== 'brains_public'
                  "
                >
                  <v-btn text color="success" @click="edit('age')">
                    edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <!-- Cell Labels -->
            <v-form
              ref="form"
              v-model="currentBrain.cellLabels.updatable"
              @submit.prevent
            >
              <v-row v-if="currentBrain.cellLabels.editable" dense>
                <v-col cols="3" class="pb-5">Cell Labels</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="currentBrain.cellLabels.dispValue"
                    :items="conditions.cellLabels.items"
                    chips
                    multiple
                    name="cellLabels"
                    item-text="Title"
                    item-value="ItemId"
                  >
                    <template v-slot:selection="{item}">
                      <v-chip
                        :color="'#' + item.Color"
                        :dark="!isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ item.Title }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="3" class="pb-5">
                  <template v-if="currentBrain.cellLabels.updatable">
                    <v-btn
                      icon
                      color="success"
                      class="mr-2 ml-3"
                      @click="save('CellLabels', 'cellLabels')"
                      :loading="currentBrain.cellLabels.loading"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn icon class="mr-2 ml-3" disabled>
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <v-btn text color="warning" @click="cancel('cellLabels')">
                    cancel
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else dense>
                <v-col cols="3" class="pb-5">Cell Labels</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="currentBrain.cellLabels.dispValue"
                    :items="conditions.cellLabels.items"
                    chips
                    multiple
                    readonly
                    name="cellLabels"
                    item-text="Title"
                    item-value="ItemId"
                  >
                    <template v-slot:selection="{item}">
                      <v-chip
                        :color="'#' + item.Color"
                        :dark="!isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ item.Title }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="3"
                  class="pb-5"
                  v-if="
                    $route.name !== 'brains_share' &&
                      $route.name !== 'brains_public'
                  "
                >
                  <v-btn text color="success" @click="edit('cellLabels')">
                    edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <!-- Experiment Labels -->
            <v-form
              ref="form"
              v-model="currentBrain.experimentLabels.updatable"
              @submit.prevent
            >
              <v-row v-if="currentBrain.experimentLabels.editable" dense>
                <v-col cols="3" class="pb-5">Experiment Labels</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="currentBrain.experimentLabels.dispValue"
                    :items="conditions.experimentLabels.items"
                    chips
                    multiple
                    name="experimentLabels"
                    item-text="Title"
                    item-value="ItemId"
                  >
                    <template v-slot:selection="{item}">
                      <v-chip
                        :color="'#' + item.Color"
                        :dark="!isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ item.Title }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="3" class="pb-5">
                  <template v-if="currentBrain.experimentLabels.updatable">
                    <v-btn
                      icon
                      color="success"
                      class="mr-2 ml-3"
                      @click="save('ExperimentLabels', 'experimentLabels')"
                      :loading="currentBrain.experimentLabels.loading"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn icon class="mr-2 ml-3" disabled>
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <v-btn
                    text
                    color="warning"
                    @click="cancel('experimentLabels')"
                  >
                    cancel
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else dense>
                <v-col cols="3" class="pb-5">Experiment Labels</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="currentBrain.experimentLabels.dispValue"
                    :items="conditions.experimentLabels.items"
                    chips
                    multiple
                    readonly
                    name="experimentLabels"
                    item-text="Title"
                    item-value="ItemId"
                  >
                    <template v-slot:selection="{item}">
                      <v-chip
                        :color="'#' + item.Color"
                        :dark="!isTextColorDark('#' + item.Color)"
                        class="ma-1"
                      >
                        {{ item.Title }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  cols="3"
                  class="pb-5"
                  v-if="
                    $route.name !== 'brains_share' &&
                      $route.name !== 'brains_public'
                  "
                >
                  <v-btn text color="success" @click="edit('experimentLabels')">
                    edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <!-- Notes -->
            <v-form
              ref="form"
              v-model="currentBrain.notes.updatable"
              @submit.prevent
            >
              <v-row v-if="currentBrain.notes.editable" dense>
                <v-col cols="3" class="pb-5">Notes</v-col>
                <v-col cols="6">
                  <v-textarea
                    outlined
                    v-model="currentBrain.notes.dispValue"
                    name="notes"
                    :rules="currentBrain.notes.rules"
                  ></v-textarea>
                </v-col>
                <v-col cols="3" class="pb-5">
                  <template v-if="currentBrain.notes.updatable">
                    <v-btn
                      icon
                      color="success"
                      class="mr-2 ml-3"
                      @click="save('Notes', 'notes')"
                      :loading="currentBrain.notes.loading"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn icon class="mr-2 ml-3" disabled>
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <v-btn text color="warning" @click="cancel('notes')">
                    cancel
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-else dense>
                <v-col cols="3" class="pb-5">Notes</v-col>
                <v-col cols="6">
                  <v-textarea
                    v-model="currentBrain.notes.dispValue"
                    outlined
                    readonly
                    color="gray"
                    name="notes"
                  ></v-textarea>
                </v-col>
                <v-col
                  cols="3"
                  class="pb-5"
                  v-if="
                    $route.name !== 'brains_share' &&
                      $route.name !== 'brains_public'
                  "
                >
                  <v-btn text color="success" @click="edit('notes')">
                    edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <!-- Downloads -->
            <template v-if="currentBrain.preprocessingStatus == 'complete'">
              <v-row dense>
                <v-col cols="3" class="mt-3 pb-5">Downloads</v-col>
                <v-col cols="6">
                  <v-select
                    v-model="selectedDownloadType"
                    :items="downloadTypes"
                    item-text="display"
                    item-value="value"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="3" v-if="downloadWaiting">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    class="ml-10"
                  ></v-progress-circular>
                </v-col>
                <v-col cols="3" v-else>
                  <v-btn
                    color="blue-grey"
                    text
                    class="mt-3 mr-3 text-none"
                    :disabled="
                      $route.name === 'brains_public' &&
                        currentBrain.publicAccess &&
                        myPlan === 'free'
                    "
                    @click="download()"
                  >
                    Download
                    <v-icon class="ml-1" dark>mdi-cloud-download</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <!-- Archive and 3D Viewer -->
            <v-row>
              <v-col
                class="text-right"
                v-if="currentBrain.preprocessingStatus == 'complete'"
              >
                <v-btn
                  :href="'/brains/viewer/' + currentBrain.id"
                  target="_blank"
                  rel="noopener"
                  text
                  color="primary"
                  class="text-none"
                >
                  <v-icon right dark>mdi-rotate-3d</v-icon>
                  <span class="ml-3">Launch 3D viewer</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                class="text-right mr-4"
                v-if="
                  $route.name === 'brains_public' &&
                    currentBrain.publicAccess &&
                    (myPlan === 'premium' || myPlan == 'standard')
                "
              >
                <v-btn
                  color="cyan"
                  class="white--text"
                  @click="importBrain()"
                  :loading="importLoading"
                >
                  <v-icon dark>mdi-import</v-icon>
                  <span class="ml-1">Import...</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleting" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Now deleting...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- profile dialog -->
    <template v-show="profileDialog">
      <profile-dialog
        :profile-dialog="profileDialog"
        :profile="currentBrain.owner.info"
        @setProfileDialog="setProfileDialog"
      ></profile-dialog>
    </template>
    <share-dialog
      v-show="shareDialog"
      :type="'brain'"
      :share-dialog="shareDialog"
      :id="currentBrain.id"
      :is-public-before="currentBrain.publicAccess"
      @setShareDialog="setShareDialog"
      @initParent="$emit('initBrains', false)"
    />
    <confirm-dialog ref="confirm" />
  </div>
</template>

<script>
import {mapState} from 'vuex'

import BrainStatus from '@/components/brain/BrainStatus.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import ShareDialog from '@/components/ShareDialog.vue'
import ProfileDialog from '@/components/account/ProfileDialog.vue'

export default {
  name: 'detailDialog',
  components: {
    BrainStatus,
    ConfirmDialog,
    ShareDialog,
    ProfileDialog,
  },
  props: {
    detailDialog: {
      type: Boolean,
      default: false,
    },
    currentBrain: {
      type: Object,
      default: null,
    },
    brains: {
      type: Array,
      default: null,
    },
    conditions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      downloadTypes: [
        {
          display: 'Structure image (raw)',
          value: 'structure_raw',
        },
        {
          display: 'Structure image (aligned)',
          value: 'structure_transf',
        },
        {
          display: 'Cell table (raw)',
          value: 'cell_raw',
        },
        {
          display: 'Cell table (aligned)',
          value: 'cell_transf',
        },
        {
          display: 'Affine transformation',
          value: 'affine_transf',
        },
        {
          display: 'Forward warp transformation',
          value: 'forward_transf',
        },
        {
          display: 'Inverse warp transformation',
          value: 'inverse_transf',
        },
        {
          display: 'Summary table',
          value: 'summary',
        },
        {
          display: 'NCC raw',
          value: 'ncc_raw',
        },
        {
          display: 'NCC plot',
          value: 'ncc_coronal_plot',
        },
      ],
      selectedDownloadType: {
        display: 'Structure image (raw)',
        value: 'structure_raw',
      },
      deleting: false,
      downloadWaiting: false,
      shareDialog: false,
      profileDialog: false,
      isUploading: false,
      selectedFile: null,
      myPlan: '',
      importLoading: false,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      profile: (state) => state.auth.userProfile,
    }),
    irregularExtension: function() {
      return (
        this.selectedFile &&
        !this.selectedFile.type.match('image/jpeg') &&
        !this.selectedFile.type.match('image/png')
      )
    },
  },
  methods: {
    async deleteThis() {
      if (
        await this.$refs.confirm.open(
          'Are you sure you want to delete this data?',
          'Yes'
        )
      ) {
        this.deleting = true
        await this.deleteBrain(this.currentBrain.id)
        this.$emit('initBrains')
        this.deleting = false
        this.$emit('setDetailDialog', false)
      }
    },
    async download() {
      this.downloadWaiting = true
      const result = await this.downloadBrainDetail(
        this.currentBrain.id,
        this.selectedDownloadType.value
      )
      if (!result) {
        this.downloadWaiting = false
        return
      }
      try {
        const link = document.createElement('a')
        link.href = result.data.DownloadUrl
        link.click()
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
      }
      this.downloadWaiting = false
    },
    setDetailDialog(show) {
      this.$emit('setDetailDialog', show)
    },
    setShareDialog(show) {
      this.shareDialog = show
    },
    setProfileDialog(isShow) {
      this.profileDialog = isShow
    },
    async save(attributeName, optionName) {
      this.currentBrain[optionName].loading = true
      const attributeValue =
        optionName == 'age'
          ? this.currentBrain[optionName].dispValue *
            this.currentBrain[optionName].periods[
              this.currentBrain[optionName].dispPeriod
            ]
          : this.currentBrain[optionName].dispValue
      const result = await this.setBrainAttribute(
        this.currentBrain.id,
        attributeName,
        attributeValue
      )
      if (!result) {
        this.currentBrain[optionName].loading = false
        return
      }
      await this.refresh(optionName)
      this.currentBrain[optionName].loading = false
      this.currentBrain[optionName].editable = false
    },
    async refresh(optionName) {
      const value = []
      const dispValue = []

      switch (optionName) {
        case 'cellLabels':
          for (const cellLabel of this.currentBrain[optionName].dispValue) {
            const label = await this.getMyTagsById('marker', cellLabel)
            if (!label) {
              continue
            }
            value.push(label)
            dispValue.push(label.ItemId)
          }
          this.currentBrain[optionName].value = value
          this.currentBrain[optionName].dispValue = dispValue
          break

        case 'experimentLabels':
          for (const experimentLabel of this.currentBrain[optionName]
            .dispValue) {
            const label = await this.getMyTagsById(
              'experiment',
              experimentLabel
            )
            if (!label) {
              continue
            }
            value.push(label)
            dispValue.push(label.ItemId)
          }
          this.currentBrain[optionName].value = value
          this.currentBrain[optionName].dispValue = dispValue
          break

        case 'age':
          this.currentBrain[optionName].period = this.currentBrain[
            optionName
          ].dispPeriod
          this.currentBrain[optionName].value = this.currentBrain[
            optionName
          ].dispValue
          break

        case 'thumbnail':
          const image = await this.getBrainThumbnailById(this.currentBrain.id)
          if (!image) {
            return
          }
          this.currentBrain[optionName] = image
          this.isUploading = false
          break

        default:
          this.currentBrain[optionName].value = this.currentBrain[
            optionName
          ].dispValue
          break
      }
    },
    cancel(optionName) {
      this.currentBrain[optionName].dispValue = this.currentBrain[
        optionName
      ].value
      if (optionName == 'age') {
        this.currentBrain[optionName].dispPeriod = this.currentBrain[
          optionName
        ].period
      }
      this.currentBrain[optionName].editable = false
    },
    edit(optionName) {
      this.currentBrain[optionName].editable = true
    },
    selectFile() {
      this.selectedFile = null
      window.addEventListener('focus', () => {}, {once: true})

      this.$refs.uploader.click()
    },
    async uploadThumbnail(e) {
      this.selectedFile = e.target.files[0]

      if (this.irregularExtension) {
        return
      }

      this.isUploading = true
      const result = await this.setBrainThumbnailById(
        this.currentBrain.id,
        this.selectedFile
      )
      if (!result) {
        this.isUploading = false
        return
      }
      await this.refresh('thumbnail')
    },
    async importBrain() {
      if (
        await this.$refs.confirm.open(
          'You are attempting to import this brain into your databse.',
          'Continue'
        )
      ) {
        this.importLoading = true
        const importedBrain = await this.importBrainById(this.currentBrain.id)
        this.importLoading = false

        if (importedBrain) {
          this.$router.push({name: 'brains_list'})
        }
      }
    },
  },
  async mounted() {
    const myPlan = await this.getMyPlan()
    if (myPlan.data && myPlan.data.CurrentPlan) {
      this.myPlan = myPlan.data.CurrentPlan
    }
  },
}
</script>

<style lang="scss">
.brain-thumbnail {
  width: 100%;
  height: 220px;
  margin: auto;
  & > div {
    & > img {
      display: none;
    }
    &.viewer-backdrop {
      background-color: rgb(0, 0, 0);
    }
    .viewer-one-to-one,
    .viewer-navbar,
    .viewer-prev,
    .viewer-play,
    .viewer-next,
    .viewer-rotate-left,
    .viewer-rotate-right,
    .viewer-flip-horizontal,
    .viewer-flip-vertical {
      display: none;
    }
    .viewer-zoom-out {
      float: right;
    }
    &:last-of-type {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>

<style scoped>
.v-form > div {
  align-items: center;
}
.v-select {
  margin-top: 0;
  padding-top: 0;
}
.v-chip--disabled {
  opacity: 1;
}
</style>
